import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const usePromotedTools = () => {
  return useQuery({
    queryKey: ["promoted-tools"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("tool_promotions")
        .select("tool_id")
        .eq("is_promoted", true);

      if (error) throw error;
      return data?.map((p) => p.tool_id) || [];
    },
  });
};
